import { apiClient } from "./apiClient";

/**
 * GAP in the endpoint only, not the data -- app.ForagePlants and
 * app.PlantPhenologyLogs (V013) are real tables already populated by
 * api/functions/blooms.py (list_plants, log_bloom_observation), so "plant
 * coverage" and "user-reported vs. predicted bloom dates" are both
 * straightforward aggregations over data that already exists. There's just
 * no admin endpoint doing that aggregation yet -- a low-risk addition
 * (mostly COUNT/AVG queries) compared to most of this app's other gaps.
 */
export const bloomAnalyticsApi = {
  plantCoverage: () => apiClient.get("/management/analytics/bloom/plant-coverage").then((r) => r.data),
  userAdditions: () => apiClient.get("/management/analytics/bloom/user-additions").then((r) => r.data),
  phenologyAccuracy: () => apiClient.get("/management/analytics/bloom/phenology-accuracy").then((r) => r.data),
};
